export default {
  gameDifficulty: {
    easy: '简单',
    medium: '中等',
    hard: '困难',
  },
  editButton: '编辑',
  imgEditDialog: '编辑',
  imgUploadDialog: '上传',
  downloadModel: '下载模型及蓝本骨骼',
  uploadCover: '上传封面图',
  difficultyV1: {
    warningText1: '所填数字已超上限',
    warningText2: '所填数字已超上限',
    warningText3: '请输入有效的数字',
  },
  difficultyV2: {
    alertText: '数据格式不正确，请使用数字、数组或字符串',
  },
  difficultyV3: {
    alertText: '配置数据格式错误，请联系我们',
    alertDesc: {
      config: '配置：',
      error: '错误详细信息：',
    },
    inputTips: '只允许输入1-50个字符',
    inputItem: {
      required: '文本框不可为空',
      placeholder: '只允许输入1-50个字符',
    },
    inputNumberTips: '只允许输入数字',
    inputNumberItem: {
      required: '文本框不可为空',
      placeholder: '只允许输入数字',
    },
    checkboxItem: {
      required: '选项不可为空',
    },
    unKnowText: '未知类型，请检查配置',
  },
  difficultySlider: {
    rangeText: '调整拖拽区间',
    submit: '确定',
    cancle: '取消',
    title: '调整',
    form: {
      min: {
        required: '最小值不能为空',
        label: '最小值',
        warningLable: '数值',
        warningText1: '请输入有效的整数',
        warningText2: '所填数字已超上限',
        warningText3: '所填数字已超最小限制',
        warningText4: '最小值不可大于等于最大值',
      },
      max: {
        required: '最大值不能为空',
        label: '最大值',
      },
    },
  },
  previewer: {
    title: '刷新',
    loadingText: '加载中',
    selectText: '请选择',
    selectLanguage: '预览语言选择',
    selectDevice: '预览设备选择',
    selectVersion: '预览组合选择',
    scenes: {
      start: '试玩环节',
      ending: '结束环节',
    },
    previewSuccess: '生成预览链接成功',
    qrcodeText: '手机查看',
  },
  saveSuccess: '保存成功',
  saveFail: '保存失败',
  savingWarning: '制作素材中，不允许执行其它操作',
  saveButton: '保存',
  withoutTemplateId: 'URL上没有版本ID',
  resourceNotSupport: '不支持该类型资源',
  resourceDialog: {
    uploadRuleLabel: '上传内容格式限制：',
    imageSize: '图片尺寸：',
    frameSequence: {
      label: '序列帧格式要求：',
      picName: '图片命名要求：',
      imageSize: '图片尺寸及帧数',
    },
    dragonBones: {
      label: '龙骨格式要求：',
    },
    video: {
      format: '支持上传Mp4（视频中要求去掉声音）',
    },
    model: {
      label: '格式：',
      format: 'zip格式（包含gltf/glb/(glb+bin)+jpg/png）',
      rules: '查看模型上传规范',
      rulesTip:
        '网格和骨骼缩放要保持单位一致<br />使用我们的蓝本骨骼进行蒙皮绑骨<br />bip001需要加入蒙皮',
    },
    resourceEdit: '素材编辑',
    submitButton: '确 认',
    cancleButton: '取 消',
    uploadWarning: '同一个资源位，不可上传相同资源',
    uploadingWarning: '上传素材中不允许关闭弹窗',
    fileUpload: {
      label: '文件大小限制：',
      default: '最大1MB',
      frameSequence: '最大8MB',
      dragonBones: '最大1MB',
      video: '最大3MB',
      model: '最大5MB',
    },
    fileMetaData: {
      name: '名称',
      format: '格式',
      fileSize: '文件大小',
      size: '尺寸',
      imageSize: '图片尺寸',
      videoSize: '视频尺寸',
      duration: '音乐时长',
    },
    handlerRelated: {
      edit: '编辑',
      delete: '删除',
      update: '替换',
      delWarningText1: '基础包内容不允许删除',
      delWarningText2: '默认内容不允许删除',
      delWarningText3: '在线制作素材不允许删除',
      delTips: '确定删除该资源吗？',
      download: '下载',
      operation: '操作',
    },
  },
  resourceUploader: {
    uploadButton: '本地上传',
    uploadFail: '上传失败，请重新尝试',
    imgLoadFail: '读取图片失败',
    warningText1: '序列帧大小不可超过3MB',
    warningText2: '龙骨大小不可超过1MB',
    warningText3: '音频大小不可超过1MB',
    warningText4: '图片大小不可超过1MB',
    videoWarningText: '视频大小不可超过3MB',
    tagLabelTips: '标签有助于算法的学习，以提炼出更精准高效的资产组合方案',
    tagLabel: '标签',
    editLabel: '编辑',
    tagPlaceholder: '请选择标签',
    audioLabel: '音乐',
    audioUploadTitle: '上传',
    cancel: '取 消',
    submit: '确 认',
    uploadingTips: '当上传文件中不允许关闭弹窗',
    assetNotExist: '该资产已被删除，请重新选择',
  },
  languageSelector: {
    error: {
      noDefaultLanguage: '没有默认语言',
    },
  },
  difficultySelect: {
    addText: '增加',
  },
  editResourceDialog: {
    title: {
      image: '图片',
      audio: '声音',
      dragonBones: '龙骨',
      movieClip: '序列帧',
      model: '3D模型',
    },
  },
  resource: {
    noTagTips: '该元素尚未打标签，双击去添加',
    globalNoTagTips: 'DCO 资源需要打上标签',
  },
  multiCustom: {
    addBtnTips: '增加组合',
    numTips: '可玩广告组合数:',
    multiCategory: '多组合资产',
  },
  qrcodeScan: {
    text: '预览',
  },
  editing: '素材正在被编辑，请稍后重试',
  textEditButton: {
    applyToOtherLanguage: '应用到其他语言',
    applyToOtherLanguageTips: '字体和字号不包括',
    applyToScreen: ['应用到横屏', '应用到竖屏'],
    languageAlert: '成功运用到其他语言',
    ScreenAlert: ['成功运用到横屏 ', '成功运用到竖屏'],
  },
  screen: {
    title: '屏幕适配',
    horizontal: '横屏',
    vertical: '竖屏',
    fovOffset: 'FOV偏移值',
    orthoHeightOffset: '正交视口大小偏移',
  },
  scene: {
    title: '相机',
    defaultScene: '默认相机{idx}',
    polarAngle: '极角',
    azimuthAngle: '方位角',
    radialDistance: '径向距离',
    viewOffsetX: 'X轴视角偏移',
    viewOffsetY: 'Y轴视角偏移',
    viewOffsetZ: 'Z轴视角偏移',
    dampingFactor: '阻尼系数',
  },
  modelEdit: {
    title: '模型编辑',
    updateBtn: '替换模型',
    basic: {
      title: '基础',
      translate: '位置',
      rotate: '旋转',
      scale: '缩放',
    },
    appearance: {
      title: '外观',
      partsOne: '部位1',
      partsTwo: '部位2',
      partsThree: '部位3',
      partsFour: '部位4',
      hub: '色相',
      saturation: '饱和度',
      lightness: '明度',
      partsTitle: '部位改色',
      paramTitle: '材质参数',
      mainColor: '主颜色-叠色',
      occlusion: '环境遮蔽',
      roughness: '粗糙度',
      metallic: '金属光泽',
      specularIntensity: '镜面强度',
      emissive: '自发光颜色',
    },
    action: {
      title: '动作',
      action: '动作',
      speed: '速率',
      sharedActionTip: '存在其他模型共用该动作，将会一同被修改:',
      keyFrame: '关键帧调整',
      keyFrameSlide: '在右侧预览区调整菱形滑块。',
      playSpecialEffects: '动作播放到此帧，则播放特效',
      changeNumber: '动作播放到此帧，则产生数值变化、例如伤害、加血',
    },
    viewer: {
      editBefore: '修改前',
      editAfter: '修改后',
    },
    cancelBtn: '取消',
    saveBtn: '保存',
    noResult: '不支持参数调整',
  },
}
